// ================================
// src/lib/proUnlock.ts — FINAL
// - 로컬스토리지 기반 Pro 해금 (1시간 기본)
// - 키 두 가지 모두 지원: "signal.proUntil" / "signal_proUntil"
// ================================
const KEYS = ["signal.proUntil", "signal_proUntil"] as const;

const lsGet = (k: string) => { try { return localStorage.getItem(k); } catch { return null; } };
const lsSet = (k: string, v: string) => { try { localStorage.setItem(k, v); } catch {} };

export function readProUntil(): number {
  for (const k of KEYS) {
    const v = lsGet(k);
    if (v && Number.isFinite(+v)) return +v;
  }
  return 0;
}

export function writeProUntil(until: number) {
  for (const k of KEYS) lsSet(k, String(until));
}

export function grantPro(ms = 60 * 60 * 1000) {
  const u = Date.now() + ms;
  writeProUntil(u);
  return u;
}

export function isProNow() {
  const u = readProUntil();
  return Number.isFinite(u) && Date.now() < u;
}